module.exports = __webpack_public_path__ + "img/bulb2.df190da8.png";